import {Industry} from "./industry";
import { MemberAssignment } from "./memberAssignment";
import {Client} from "./client";
import {ListEntry} from "./colDef";
import {User} from "./user";
import {CategoryAssignment} from "./categoryAssignment";
import {Skill} from "./skill";
import {Development} from "./development";
import {Certification} from "./certification";
import {FileEntry} from "./fileEntry";

export enum ProjectStatus {
  ARCHIVED = 0,
  ACTIVE = 1,
  PENDING = 2
}

export interface Phase extends ListEntry{
  Project_id?: number,
  description?: string,
  members?: MemberAssignment[]
}

export interface Project extends ListEntry{
  id: number,
  name: string,
  description: string,
  start_on: Date|string,
  end_on: Date|string,
  due_on: Date|string,
  color: string,
  company: string,
  created_at?: number|Date,
  created_by?: string|User,
  updated_at?: number|Date,
  archived_at?: number|Date,
  archived_by?: string|User,
  status: ProjectStatus,
  Client_id?: number,
  client?: Client,
  for_client?: Client,
  industries?: Industry[],
  categories?: CategoryAssignment[],
  skills?: Skill[],
  developments?: Development[],
  certifications?: Certification[],
  phases?: Phase[],
  logo?: FileEntry,
  billable?: boolean | null,
  is_billable?: boolean,
  /** Present when this project was converted from a CRM deal (reverse-nav, §14). */
  crm_origin?: { Submission_id: number, Opportunity_id: number, opportunity_title?: string | null } | null,
}
